/* eslint-disable vue/no-side-effects-in-computed-properties */
<!-- SCREENING ASSETS component -->
<template>
  <div style="width: 100%; padding:0; margin:0;">
    <!--<md-card id="screeningassets" class="md-with-hover">-->

    <!--
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon"><md-icon>list_alt</md-icon></div>
        <h4 class="title">Screening Artifacts</h4>
      </md-card-header>
    -->
    <span style="margin-left: 15px; font-size: .8rem; font-weight: 400; color: green">Completed Tests</span>
    <!--<md-card-content style="padding: 0px;">-->

    <!--
        <div class="md-layout" >
          <div class="md-layout-item md-size-40" align="center">
            <label class="md-caption" style="font-weight:bold;">DATA</label>
            <hr />
          </div>
          <div class="md-layout-item md-size-60" align="center">
            <label class="md-caption" style="font-weight:bold;">IMAGES</label>
            <hr />
          </div>
        </div>
        -->
    <div class="md-layout">
      <div class="md-layout-item" align="center">
        <md-radio v-model="m_history" :value="v_history" :disabled="d_history" class="sasset">Hist</md-radio>
        <md-radio v-model="m_vision" :value="v_vision" :disabled="d_vision" class="sasset">Vision</md-radio>
        <md-radio v-model="m_pressure" :value="v_pressure" :disabled="d_pressure" class="sasset">IOP</md-radio>
        <md-radio v-model="m_ant" :value="v_ant" :disabled="d_ant" class="sasset">ANT</md-radio>
        <md-radio v-model="m_ext" :value="v_ext" :disabled="d_ext" class="sasset">EXT</md-radio>
        <md-radio v-model="m_cor" :value="v_cor" :disabled="d_cor" class="sasset">COR</md-radio>
        <md-radio v-model="m_pac" :value="v_pac" :disabled="d_pac" class="sasset">PAC</md-radio>
        <md-radio v-model="m_opa" :value="v_opa" :disabled="d_opa" class="sasset">OPA</md-radio>
        <md-radio v-model="m_fun" :value="v_fun" :disabled="d_fun" class="sasset">FUN</md-radio>
        <md-radio v-model="m_mac" :value="v_mac" :disabled="d_mac" class="sasset">MAC</md-radio>
        <md-radio v-model="m_nrv" :value="v_nrv" :disabled="d_nrv" class="sasset">NRV</md-radio>
      </div>
    </div>

    <!--</md-card-content>

    </md-card>-->
  </div>
</template>
<script>
import { mapGetters } from "vuex"
export default {
  name: "InfoScreeningAssets",
  data() {
    return {
      m_history: null,
      d_history: true,
      m_ant: null,
      d_ant: true,
      m_vision: null,
      d_vision: true,
      m_pressure: null,
      d_pressure: true,
      m_ext: null,
      d_ext: true,
      m_cor: null,
      d_cor: true,
      m_pac: null,
      d_pac: true,
      m_opa: null,
      d_opa: true,
      m_fun: null,
      d_fun: true,
      m_mac: null,
      d_mac: true,
      m_nrv: null,
      d_nrv: true
    }
  },

  computed: {
    ...mapGetters(["screeningAssets"]),

    v_history: {
      get: function() {
        if (this.screeningAssets.History) {
          this.m_history = true
          this.d_history = false
          return true
        }
      },
      set: function(val) {
        return
      }
    },
    v_ant: {
      get: function() {
        if (this.screeningAssets.ANTSEG) {
          this.m_ant = true
          this.d_ant = false
          return true
        }
      },
      set: function(val) {
        return
      }
    },
    v_vision: {
      get: function() {
        if (this.screeningAssets.Vision) {
          this.m_vision = true
          this.d_vision = false
          return true
        }
      },
      set: function(val) {
        return
      }
    },
    v_pressure: {
      get: function() {
        if (this.screeningAssets.Pressure) {
          this.m_pressure = true
          this.d_pressure = false
          return true
        }
      },
      set: function(val) {
        return
      }
    },
    v_ext: {
      get: function() {
        if (this.screeningAssets.External) {
          this.m_ext = true
          this.d_ext = false
          return true
        }
      },
      set: function(val) {
        return
      }
    },
    v_cor: {
      get: function() {
        if (this.screeningAssets.Corneal) {
          this.m_cor = true
          this.d_cor = false
          return true
        }
      },
      set: function(val) {
        return
      }
    },
    v_pac: {
      get: function() {
        if (this.screeningAssets.Pachymetry) {
          this.m_pac = true
          this.d_pac = false
          return true
        }
      },
      set: function(val) {
        return
      }
    },
    v_opa: {
      get: function() {
        if (this.screeningAssets.Opacity) {
          this.m_opa = true
          this.d_opa = false
          return true
        }
      },
      set: function(val) {
        return
      }
    },
    v_fun: {
      get: function() {
        if (this.screeningAssets.Fundus) {
          this.m_fun = true
          this.d_fun = false
          return true
        }
      },
      set: function(val) {
        return
      }
    },
    v_mac: {
      get: function() {
        if (this.screeningAssets.Macula) {
          this.m_mac = true
          this.d_mac = false
          return true
        }
      },
      set: function(val) {
        return
      }
    },
    v_nrv: {
      get: function() {
        if (this.screeningAssets.Nerve) {
          this.m_nrv = true
          this.d_nrv = false
          return true
        }
      },
      set: function(val) {
        return
      }
    }
  },
  mounted: function() {
    this.$forceUpdate()
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
#screeningassets {
  width: 95%;
  margin-left: 20px;
  display: inline-block;
  vertical-align: top;
}
.label {
  font-size: 0.7rem;
  //font-weight: 500;
}
.field {
  font-size: 0.95rem;
  font-weight: 400;
  color: rgb(0, 0, 139);
}
.md-chekbox {
  padding: 0px;
  margin: 0px;
}
.sasset {
  padding-left: 5px !important;
  color: rgb(0, 0, 0);
  font-size: 0.8rem;
  line-height: 20px;
}
.md-radio .md-radio-label {
  padding-left: 5px !important;
  color: rgb(0, 0, 0) !important;
}
</style>
